import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import { supabase } from "./supabase";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [ready, setReady] = useState(false);
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) {
        setReady(true);
      } else {
        setInvalidLink(true);
      }
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      if (event === "PASSWORD_RECOVERY" || session) {
        setReady(true);
        setInvalidLink(false);
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleReset = async () => {
    if (!password || !confirmPassword) {
      setError("Please fill in both fields.");
      return;
    }
    if (password.length < 6) {
      setError("Password must be at least 6 characters.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setLoading(true);
    setError("");
    const { error: updateError } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (updateError) {
      setError(updateError.message);
    } else {
      setSuccess(true);
    }
  };

  const inputStyle = {
    width: "100%",
    background: "#F5F0E8",
    border: "1.5px solid #EDE8DF",
    borderRadius: 8,
    padding: "11px 14px",
    color: "#1A1A2E",
    fontSize: 14,
    fontFamily: "var(--font-body)",
    outline: "none",
    marginBottom: 14,
    boxSizing: "border-box",
  };

  const labelStyle = {
    fontSize: 11,
    color: "#888",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: 6,
    display: "block",
  };

  return (
    <div style={{ fontFamily: "var(--font-body)", background: "#F5F0E8", minHeight: "100vh", color: "#1A1A2E" }}>
      <Navbar />

      <div style={{ maxWidth: 440, margin: "0 auto", padding: "56px 24px" }}>

        {success ? (
          <>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <div style={{ width: 56, height: 56, background: "#1B3A6B", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12"/>
                </svg>
              </div>
              <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
                Password <span style={{ color: "#1B3A6B" }}>Updated</span>
              </h1>
              <p style={{ color: "#888", fontSize: 13 }}>You can now sign in with your new password.</p>
            </div>
            <div style={{ background: "#fff", border: "1px solid #EDE8DF", borderRadius: 20, padding: 32, textAlign: "center" }}>
              <button
                onClick={() => window.location.href = "/login"}
                style={{ width: "100%", background: "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: "#fff", fontWeight: 800, fontSize: 15, cursor: "pointer", fontFamily: "var(--font-body)" }}
              >
                Go to Sign In
              </button>
            </div>
          </>
        ) : invalidLink ? (
          <>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <div style={{ width: 56, height: 56, background: "#F5F0E8", border: "1px solid #EDE8DF", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#C0392B" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
              </div>
              <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
                Link <span style={{ color: "#1B3A6B" }}>Expired</span>
              </h1>
              <p style={{ color: "#888", fontSize: 13 }}>This password reset link is invalid or has expired.</p>
            </div>
            <div style={{ background: "#fff", border: "1px solid #EDE8DF", borderRadius: 20, padding: 32, textAlign: "center" }}>
              <button
                onClick={() => window.location.href = "/login"}
                style={{ width: "100%", background: "transparent", border: "1.5px solid #EDE8DF", borderRadius: 99, padding: "13px", color: "#888", fontWeight: 600, fontSize: 14, cursor: "pointer", fontFamily: "var(--font-body)" }}
              >
                Back to Sign In
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={{ textAlign: "center", marginBottom: 32 }}>
              <div style={{ width: 56, height: 56, background: "#1B3A6B", borderRadius: 14, display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/>
                </svg>
              </div>
              <h1 style={{ fontSize: 26, fontWeight: 900, color: "#1A1A2E", margin: "0 0 6px", letterSpacing: "-0.02em" }}>
                Set New <span style={{ color: "#1B3A6B" }}>Password</span>
              </h1>
              <p style={{ color: "#888", fontSize: 13 }}>Choose a new password for your Forge SA account.</p>
            </div>

            <div style={{ background: "#fff", border: "1px solid #EDE8DF", borderRadius: 20, padding: 32 }}>
              <label style={labelStyle}>New Password</label>
              <input
                type="password"
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={inputStyle}
              />

              <label style={labelStyle}>Confirm Password</label>
              <input
                type="password"
                placeholder="Re-enter your password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={inputStyle}
              />

              {error && (
                <div style={{ background: "rgba(192,57,43,0.07)", border: "1px solid rgba(192,57,43,0.2)", borderRadius: 8, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: "#C0392B" }}>
                  {error}
                </div>
              )}

              <button
                onClick={handleReset}
                disabled={loading || !ready}
                style={{ width: "100%", background: loading || !ready ? "#EDE8DF" : "#1B3A6B", border: "none", borderRadius: 99, padding: "14px", color: loading || !ready ? "#888" : "#fff", fontWeight: 800, fontSize: 15, cursor: loading || !ready ? "not-allowed" : "pointer", fontFamily: "var(--font-body)" }}
              >
                {loading ? "Updating..." : "Update Password"}
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
}